import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const Header = ( {children} ) => {
    const [isScrolled, setIsScrolled] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={`w-full dark-gradient text-200 ${isScrolled ? 'static lg:fixed' : ''}`}>
            <div className={`flex flex-column gap-3 md:gap-0 md:flex-row m-auto w-full pl-3 pr-3 pt-4 pb-4 md:${isScrolled ? 'w-7' : 'w-9'}`}>
                <div className='flex-1 flex justify-content-center md:flex-0 md:justify-content-start'>
                    <div className={`text-3xl ${/*isScrolled ? 'block' : 'hidden'*/''}`}>
                        JANA PELIKAN
                    </div>
                    {/*<img src='JanaWEBLOGO.png' alt='Jana Pelikan' style={{height: '4rem', width: 'auto'}} />*/}
                </div>
                <div className='flex-1 flex-wrap lg:flex-nowrap justify-content-center md:justify-content-end flex'>
                    {children}
                    <Button label='Home' className='p-button-text text-300' onClick={() => navigate('/')} />
                    <Button label='Panasea' className='p-button-text text-300' onClick={() => navigate('/band')} />
                    <Button label='Music' className='p-button-text text-300' onClick={() => navigate('/music')} />
                    <Button label='Live' className='p-button-text text-300' onClick={() => navigate('/live')} />
                    <Button label='Contact' className='p-button-text text-300' onClick={() => navigate('/contact')} />
                </div>
            </div>
        </div>
    );
};

export default Header;